import { useEffect, useRef } from 'react';

export const useElementVisibility = (onVisible: () => void, threshold = 1) => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const element = ref.current;

    const observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];

        if (entry?.isIntersecting) {
          onVisible();
          observer.disconnect();
        }
      },
      {
        threshold,
      }
    );

    if (element) {
      observer.observe(element);
    }

    return () => {
      observer.disconnect();
    };
  }, [onVisible, threshold]);

  return ref;
};
